<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'CUENTACONTABLE.LBL_ADMCUENTAS' | translate}}</h1>
  </div>
</div>

<div class="grid">
  <div class="col-12 md:col-6 lg:col-6 flex gap-2">
    <button type="button" pButton icon="p-icon-add" (click)="new()" label="{{'CUENTACONTABLE.BTN_CUENTPRIN' | translate}}"
            *ngIf="btn.show && menu.agregar"></button>
    <button type="button" pButton icon="p-icon-add" (click)="newSub()" label="{{'CUENTACONTABLE.BTN_CUENTHIJO' | translate}}"
            *ngIf="btnsub.show && menu.agregar"></button>
  </div>
</div>


<div class="grid">
  <div class="col-12 md:col-4 lg:col-4">
    <p-tree id="treeBien" [value]="treeProperties" selectionMode="single"
            [(selection)]="nodeSelected"
            (onNodeSelect)="preSelect($event.node)" [loading]="loadingTree"
            (onNodeExpand)="nodeExpand($event.node)"
            >
      <ng-template let-item pTemplate="default">
        <span>{{ item.label }}</span>
      </ng-template>
    </p-tree>
  </div>
  <div class="col-12 md:col-8 lg:col-8">
    <p-panel header="{{header}}">
      <fieldset>
        <div class="grid" *ngIf="guardado">
          <div class="col-12 md:col-12 lg:col-12 text-center">
            <i class="fa fa-refresh fa-spin fa-fw"></i>
            <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
          </div>
        </div>
        <div *ngIf="!guardado">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" name="nomForm" novalidate id="idForm">
            <div class="grid" *ngIf="loadingData">
              <div class="col-12 md:col-12 lg:col-12 text-center">
                <i class="fa fa-refresh fa-spin fa-fw"></i>
                <span>{{ 'LBL_CARGANDO' | translate}}...</span>
              </div>
            </div>
            <div *ngIf="!loadingData">

              <div class="grid">
                <div class="col-6 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>{{ 'CUENTACONTABLE.LBL_CODPUC' | translate }}</label>
                    <input type="text" pInputText id="cuentaContable"
                           name="nomCuentaContable"
                           autocomplete="off"
                           formControlName="cuentaContable"
                           [maxlength]="11"
                           numero-entero-reactive
                    >
                    <div class="p-message p-messages-error p-corner-all"
                         *ngIf="submitted && f.cuentaContable.invalid">
                      {{ 'CUENTACONTABLE.LBL_CODPUC' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="codeExists">
                      <p>{{ 'BIENES.MSG_CODIGOEXISTE' | translate}}</p>
                    </div>
                  </div>
                </div>
                <div class="col-6 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'CUENTACONTABLE.LBL_CODCUENTA' | translate }}</label>
                    <div *ngIf="!cuentaContable.idCuentaContable">
                      <input type="text" pInputText id="codigo"
                             name="codigo"
                             autocomplete="off"
                             formControlName="cuentaContableCrezcamos"
                             [maxlength]="11" required
                             numero-entero-reactive
                      >
                      <div class="p-message p-messages-error p-corner-all"
                           *ngIf="submitted && f.cuentaContableCrezcamos.invalid">
                        {{ 'CUENTACONTABLE.LBL_CODCUENTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                      <div class="p-message p-messages-error p-corner-all" *ngIf="codeExists">
                        <p>{{ 'BIENES.MSG_CODIGOEXISTE' | translate}}</p>
                      </div>
                    </div>
                    <div *ngIf="cuentaContable.idCuentaContable">
                      <label class="falso-combo-texto">{{cuentaContable.cuentaContableCrezcamos}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid">
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'CUENTACONTABLE.LBL_NOMBRE' | translate }}</label>
                    <input type="text" pInputText id="nombre"
                           name="nombre"
                           autocomplete="off"
                           formControlName="descripcionCuenta"
                           [maxlength]="100" required
                           appTexto [sinCaracteres]="true" [sinComa]="false"
                    >
                    <div class="p-message p-messages-error p-corner-all"
                         *ngIf="submitted && f.descripcionCuenta.invalid">
                      {{ 'CUENTACONTABLE.LBL_NOMBRE' | translate }} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-6 lg:col-6" *ngIf="cuentaContable.nivelCuentaContable===1">
                  <div class="div-form">
                    <label>* {{'CUENTACONTABLE.LBL_TIPESTFIN' | translate}}</label>
                    <p-dropdown disableTab  id="idTipoEstadoFinanciero" name="nomIdTipoEstadoFinanciero" [options]="lisEstadosFinancieros"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                 formControlName="idTipoEstadoFinanciero"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoEstadoFinanciero.invalid">
                      {{ 'CUENTACONTABLE.LBL_TIPESTFIN' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-6 lg:col-6" *ngIf="cuentaContable.nivelCuentaContable>1">
                  <div class="div-form">
                    <label>* {{'CUENTACONTABLE.LBL_TIPESTFIN' | translate}}</label>
                    <label class="falso-combo-texto">{{cuentaContable.tipoEstadoFinanciero}}</label>
                  </div>
                </div>
              </div>
              <div class="grid" >
                <div class="col-12 md:col-6 lg:col-6" *ngIf="cuentaContable.nivelCuentaContable>1">
                  <div class="div-form">
                    <label>* {{ 'CUENTACONTABLE.LBL_CUENTASUPERIOR' | translate }}</label>
                    <label class="falso-combo-texto">{{cuentaContable.descripcionCuentaPadre}}</label>
                  </div>
                </div>

                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{ 'CUENTACONTABLE.LBL_CODIGOHOJAEVALUACION' | translate }}</label>
                    <input type="text" pInputText id="idCodigoHojaEvaluacion"
                           name="nomCodigoHojaEvaluacion"
                           autocomplete="off"
                           formControlName="codigoHojaEvaluacion"
                           maxlength="8"
                           appTexto [sinEspacio]="true"
                           [sinCaracteres]="true"
                           [sinNumeros]="false"
                           [sinPunto]="false"
                           [sinLetras]="true"
                           (blur)="validarNumero($event)"
                    >
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigoHojaEvaluacion.invalid">
                      {{ 'CUENTACONTABLE.LBL_CODIGOHOJAEVALUACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>

                    <div class="p-message p-messages-error p-corner-all"
                         *ngIf="submitted && ranIncorrecto">
                      {{ 'CUENTACONTABLE.MSG_ERRORHOJAEVALUACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>

              </div>
              <div class="grid" *ngIf="cuentaContable.nivelCuentaContable > 2">
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-checkbox formControlName="indicadorVisible" binary="true"></p-checkbox>
                    <label class="pl-2">{{'CUENTACONTABLE.LBL_VISIBLE' | translate}}</label>
                  </div>
                </div>
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-checkbox formControlName="indicadorHabilitado" binary="true"></p-checkbox>
                    <label class="pl-2">{{'LBL_HABILITADO' | translate}}</label>
                  </div>
                </div>
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-radioButton name="indicadorSuma" [value]="true" id="suma"
                                   label="{{ 'CUENTACONTABLE.LBL_SUMA' | translate}}"
                                   formControlName="indicadorSuma"></p-radioButton>
                  </div>
                </div>
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-radioButton name="indicadorSuma" [value]="false" id="resta"
                                   label="{{ 'CUENTACONTABLE.LBL_RESTA' | translate}}"
                                   formControlName="indicadorSuma"></p-radioButton>
                  </div>
                </div>
              </div>
              <div class="grid form-group" *ngIf="cuentaContable.nivelCuentaContable > 2">
                <div class="col-12 md:col-6 lg:col-6">
                  <div class="div-form">
                    <label>* {{'CUENTACONTABLE.LBL_SECCION' | translate}}:</label>
                    <p-dropdown disableTab  id="idFuncionalidadesControles" name="nomFuncionalidadesControles" [options]="lisFuncionalidadControl"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                 formControlName="seccion"
                                (onChange)="verificarFuncionalidad()"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.seccion.invalid">
                      {{ 'CUENTACONTABLE.LBL_SECCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-6 lg:col-6" *ngIf="controlesCargados">
                  <div class="div-form">
                    <label>* {{'CUENTACONTABLE.LBL_CONTROL' | translate}}:</label>
                    <p-dropdown disableTab  id="idFuncionalidadControl" name="nomFuncionalidadControl" [options]="lisControl"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                 formControlName="idFuncionalidadControl"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFuncionalidadControl.invalid">
                      {{ 'CUENTACONTABLE.LBL_CONTROL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid form-footer-buttons" *ngIf="cuentaContable.nivelCuentaContable > 2">
                <div class="form-group col-12  text-center">
                  <button pButton type="button" (click)="guardar()"
                          label="{{ 'CUENTACONTABLE.LBL_AGREGAR' | translate }}"></button>
                </div>
              </div>
              <div class="grid form-group" *ngIf="cuentaContable.nivelCuentaContable > 2">
                <div class="col-12 md:col-12 lg:col-12">
                  <div class="div-form">
                    <p-table [columns]="columnas" [loading]="carTabla" #dt
                             [value]="cargarCuentasContablesControles()" selectionMode="single" dataKey="idRangoDias"
                             [paginator]="true" [rows]="10"  paginatorPosition="bottom">
                      <ng-template pTemplate="header" let-columns>
                        <tr>
                          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                              class="text-center">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                          </th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-row>
                        <tr [pSelectableRow]="row">
                          <td class="text-center">{{row.funcionalidadControlPadre}}</td>
                          <td class="text-center">{{row.funcionalidadControl}}</td>
                          <td class="text-center">
                            <div class="btn-group" role="group">
                              <button type="button" class="p-button p-button-success btn" icon="fa fa-trash-o" data-toggle="tooltip"
                                      title="{{'BTN_ELIMINAR' | translate}}" pButton
                                      (click)="eliminarCuentaControl(row)"></button>
                            </div>
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                          <td [attr.colspan]="columns.length">{{ 'MSG_NOHAYREGISTROS' | translate}}</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </div>
              </div>
              <div class="grid form-footer-buttons" *ngIf="menu.agregar && menu.editar">
                <div class="form-group col-12 text-center">
                  <a (click)="doCancel(formulario.dirty)" class="cancelar">{{ 'BTN_CANCELAR' | translate }} </a>
                  <button pButton type="submit" formaction="" label="{{ 'BTN_GUARDAR' | translate }}"></button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </fieldset>
    </p-panel>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
